import { render } from "./EmptyContainer.vue?vue&type=template&id=7915cd1f"
import script from "./EmptyContainer.vue?vue&type=script&lang=js"
export * from "./EmptyContainer.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Frontend_PsicoApp/Frontend_PsicoApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__